import React from "react";
import "./site-chrome.css";

const quickLinks = [
    { label: "Hizmetler", href: "/services/" },
    { label: "Portfolyo", href: "/portfolio/" },
    { label: "Mağaza", href: "/store/" },
    { label: "Eğitim", href: "/education/" },
];

const contactLinks = [
    { label: "studio@modelerman.com", href: "mailto:studio@modelerman.com" },
    { label: "+90 212 000 00 00", href: "tel:+902120000000" },
];

const socialLinks = [
    { label: "Behance", href: "https://www.behance.net" },
    { label: "Instagram", href: "https://instagram.com/modeler.man" },
    { label: "LinkedIn", href: "https://www.linkedin.com" },
];

export default function SiteFooter() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="site-footer__grid">
                <div className="site-footer__brand">
                    <span className="site-footer__eyebrow">Modelerman Studio</span>
                    <h2 className="site-footer__title">Mimariyi hikayeye dönüştürüyoruz.</h2>
                    <p className="site-footer__tagline">
                        İstanbul çıkışlı tam kapsamlı görselleştirme ekibiyiz. Pitch sunumlarından satış galerisi deneyimlerine
                        kadar tek akışta teslim ediyoruz.
                    </p>
                </div>
                <div className="site-footer__column">
                    <h3>İletişim</h3>
                    <ul>
                        {contactLinks.map((item) => (
                            <li key={item.label}>
                                <a href={item.href}>{item.label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="site-footer__column">
                    <h3>Hızlı bağlantılar</h3>
                    <ul>
                        {quickLinks.map((item) => (
                            <li key={item.label}>
                                <a href={item.href}>{item.label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="site-footer__column">
                    <h3>Sosyal</h3>
                    <ul>
                        {socialLinks.map((item) => (
                            <li key={item.label}>
                                <a href={item.href} target="_blank" rel="noreferrer">
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className="site-footer__meta">
                <span>© {currentYear} Modelerman Studio</span>
                <div className="site-footer__legal">
                    <a href="/privacy">KVKK & Gizlilik</a>
                    <a href="mailto:studio@modelerman.com">Bize yazın</a>
                </div>
            </div>
        </footer>
    );
}
